<template>
  <inline-warning-message v-if="isMaintenanceMode && isSystemAdmin" class="mb-0">
    <b>Warning:</b> This client site is currently in maintenance mode. Please do not proceed with
    any actions.
  </inline-warning-message>
  <div
    v-if="isMaintenanceMode && !isSystemAdmin"
    class="maintenance-mode-page d-flex justify-center align-center mt-10"
  >
    <div class="maintenance-mode-page-content d-flex flex-column justify-center align-center">
      <div class="maintenance-mode-page-content-icon">
        <v-img :src="maintenanceModeImage" width="250" height="250" />
      </div>
      <div class="maintenance-mode-page-content-title mt-10">
        <h1 class="maintenance-title">Site Under Maintenance</h1>
      </div>
      <div class="maintenance-mode-page-content-message mt-5 text-center">
        <p class="maintenance-message">
          The site is currently undergoing maintenance. We will be back soon.
          <br />Please contact support if you need assistance.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import maintenanceModeImage from '@/assets/image/maintenance_mode.svg';
import InlineWarningMessage from '@/components/InlineWarningMessage';
export default {
  name: 'MaintenanceMode',
  components: {
    InlineWarningMessage
  },
  props: {
    isSystemAdmin: Boolean,
    isMaintenanceMode: Boolean
  },
  data() {
    return {
      maintenanceModeImage
    };
  }
};
</script>
